var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        { attrs: { modalId: _vm.modalId, size: "modal-lg" } },
        [
          _c(
            "ModalHeader",
            {
              style: { padding: "10px 10px 10px 10px" },
              attrs: {
                title: _vm.$t("xPendingPlanChangeInProgress"),
                icon: "far fa-exclamation-triangle"
              }
            },
            [
              _c("div", { staticClass: "cols-auto" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-icon-button btn-icon-button--gray",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.handleCloseClick()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]
          ),
          _c("ModalBody", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("xPendingPlanChangeExplanationText")) +
                    " "
                )
              ])
            ]),
            _c("div", { staticClass: "row mt-4 mb-3" }, [
              _c("div", { staticClass: "col" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("xPendingPlanChangeAreYouSure")) + " "
                )
              ])
            ])
          ]),
          _c("ModalFooter", [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary mr-2",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.handleCloseClick()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xNoCancelButtonText")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: {
                  type: "button",
                  disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                    _vm.currentAppConfig
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.continueToOverwritePendingChanges()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xYesContinueButtonText")) + " ")]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }